import { FC } from 'react';
import Capital from 'containers/capital/Capital';
import MerchantOrTeamBlockedInfo from 'components/merchant-or-team-blocked/MerchantOrTeamBlockedInfo';
import { selectIsActionsBlocked } from 'containers/app/appSlice';
import { useAppSelector } from 'hooks';

const CapitalPage: FC<{ isWebView?: boolean }> = ({ isWebView }) => {
  const isActionsBlocked = useAppSelector(selectIsActionsBlocked);
  if (isActionsBlocked) {
    return <MerchantOrTeamBlockedInfo title="Financing" />;
  }
  return <Capital isWebView={isWebView} />;
};

export default CapitalPage;
